import { Box, Drawer, IconButton, Typography, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';
import { colors } from '../styles/theme';
import AppLogo from './AppLogo';
import { useSections } from '../hooks/useSections';
import { ModifiedBreakPoint } from '../utils/utilityHelper';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { configState } from '../recoil/atoms';
import { aiActiveState } from '../recoil/atoms/aiMessages';
import { AssetsDashboardContext } from '../contexts/assetsDashboardContext';
import { useContext } from 'react';
import { useUserInfo } from '@terragotech/gen5-shared-components';
import { faSparkles } from '@fortawesome/pro-light-svg-icons';
interface Props {
  open: boolean;
  toggleDrawer: (value: boolean) => void;
}

const MobileDrawer = ({ toggleDrawer, open }: Props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);
  const { items } = useSections();
  const navigationItem = _.first(items.filter(o => o.title === 'Navigation'));
  const authItem = _.first(items.filter(o => o.title === 'authSection'));
  const setAiSearchOpen = useSetRecoilState(aiActiveState);
  const { isMobileView, currentPage } = useContext(AssetsDashboardContext);
  const { hasAiAnalysisAccess } = useUserInfo();

  return (
    <Drawer open={open} onClose={() => toggleDrawer(false)} className={classes.container}>
      <Box className={classes.root}>
        <Box className={classes.mainContainer}>
          <Box className={classes.header}>
            <Box className={classes.logoContainer}>
              <AppLogo className={classes.logo} />
              <Typography className={classes.title}>{config.applicationName}</Typography>
            </Box>
            <IconButton className={classes.closeButton} onClick={() => toggleDrawer(false)}>
              <FontAwesomeIcon icon={faClose} />
            </IconButton>
          </Box>
          <Box className={classes.body}>{navigationItem?.content}</Box>
          {(isMobileView || currentPage === 'home') && hasAiAnalysisAccess && (
            <Box className={classes.aiContainer}>
              <div
                className={classes.aiButton}
                onClick={() => {
                  toggleDrawer(false);
                  setAiSearchOpen(p => !p);
                }}>
                <FontAwesomeIcon className={classes.aiIcon} icon={faSparkles}></FontAwesomeIcon>
                Ask AI
              </div>
            </Box>
          )}
          <Box className={classes.footer}>{authItem?.content}</Box>
        </Box>
      </Box>
    </Drawer>
  );
};

const DRAWER_PADDING = 26;
const useStyles = makeStyles(theme => {
  const mobileBreakpoint = theme.breakpoints.down(ModifiedBreakPoint);
  return {
    container: {
      '& .MuiPaper-root.MuiDrawer-paper': {
        padding: 0,
        width: '350px',
        height: '100dvh',
        paddingBottom: 0,
        [mobileBreakpoint]: {
          width: '85%',
        },
      },
    },
    aiIcon: {
      cursor: 'pointer',
      // backgroundColor: colors.black10,
      color: theme.palette.primary.main,
      width: 20,
      height: 20,
      marginRight: 10,
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 13,
      padding: '30px 25px 23.8px 26px',
      [mobileBreakpoint]: {
        gap: 0,
        padding: '21px 20px 11px 20px',
      },
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: 0,
    },
    logoContainer: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: 12,
      padding: '0px 12px',
      [mobileBreakpoint]: {
        width: '75%',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 9,
        padding: 0,
      },
    },
    logo: {
      [mobileBreakpoint]: {
        width: 36.5,
        height: 36.5,
        padding: 4,
      },
      width: 39.1,
      height: 39.1,
      padding: 2,
    },
    title: {
      color: colors.black0,
      fontSize: 17,
      fontWeight: 500,
      fontFamily: 'Roboto',
      [mobileBreakpoint]: {
        fontSize: 14,
        fontWeight: 400,
      },
    },
    closeButton: {
      width: 24,
      height: 24,
    },
    body: {
      flexGrow: 1,
      overflow: 'auto',
      borderTop: `1px solid ${colors.black05}`,
      padding: '19px 25px 0px 25px',
      minHeight: 0,
      [mobileBreakpoint]: {
        padding: '19px 17px 0px 18px',
      },
    },
    footer: {
      flexShrink: 0,
      borderTop: `1px solid ${colors.black05}`,
      padding: '23px 25px 29px 25px',
      [mobileBreakpoint]: {
        padding: '14px 24px 18px 24px',
      },
    },
    aiContainer: {
      flexShrink: 0,
      padding: '23px 25px 29px 25px',
      [mobileBreakpoint]: {
        padding: '14px 24px 18px 24px',
      },
    },
    aiButton: {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 10,
      padding: 10,
      color: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
});
export default MobileDrawer;
